import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
export class Institucion {
  public nombre: string;
  public descripcion: string;
}
@Injectable({
  providedIn: 'root'
})
export class InstitucionService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');

  constructor(
    private http: HttpClient,
  ) { }

  public getInstituciones(): Observable<any> {
    const apiURL = this.apiURL + 'institucionesListar';
    return this.http.post(`${apiURL}`, { headers: this.headers});
  }
  public getInstucionesTemplateActivo(): Observable<any>{
    const act = {
      activo: true
    }
    const body = JSON.stringify(act);
    const apiURL = this.apiURL + 'api/instituciones-con-templates';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  public getInstitucionIdAdmi(id): Observable<any>{
    const i = {
      _id: id
    }
    const body = JSON.stringify(i);
    const apiURL = this.apiURL + 'institucionesListar';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  } 

  public postInstitucion(inst: any): Observable<any>{
    const insti: Institucion = {
      nombre: inst.nombre,
      descripcion: inst.descripcion
    }
    const body = JSON.stringify(insti);
    const apiURL = this.apiURL + 'instituciones/CrearInstitucion';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
}
